/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import ApprovalForm from '../Feature/ApprovalsFinancialAuthority/components/ApprovalForm';
import ApprovalsFinancialAuth from '../Feature/ApprovalsFinancialAuthority/components/ApprovalsFinancialAuth';
import ArrearsErrorRecord from '../Feature/Arrears/components/ArrearsErrorRecord';
import ArrearsFileList from '../Feature/Arrears/components/ArrearsFileList';
import ArrearsHistoricalFlyout from '../Feature/Arrears/components/ArrearsHistoricalFlyout';
import ArrearsHistoricalRecords from '../Feature/Arrears/components/ArrearsHistoricalRecords';
import ArrearsResources from '../Feature/Arrears/components/ArrearsResources';
import ArrearsSubmissionForm from '../Feature/Arrears/components/ArrearsSubmissionForm';
import ArrearsSubmissionListDetails from '../Feature/Arrears/components/ArrearsSubmissionListDetails';
import ArrearsSummaryReport from '../Feature/Arrears/components/ArrearsSummaryReport';
import DisplayNotificationCard from '../Feature/Arrears/components/DisplayNotificationCard';
import ReplaceArrears from '../Feature/Arrears/components/ReplaceArrears';
import SubmissionList from '../Feature/Arrears/components/SubmissionList';
import SignInComplete from '../Feature/Authentication/components/SignInComplete';
import ClaimsInventory from '../Feature/Claims/components/ClaimsInventory';
import ClaimsSubmissionForm from '../Feature/Claims/components/ClaimsSubmissionForm';
import Details from '../Feature/Claims/components/Details';
import HBTFormContext from '../Feature/Claims/components/HBTFormContext';
import IndicatorDetailsFields from '../Feature/Claims/components/IndicatorDetailsFields';
import PageHeaderComponent from '../Feature/Claims/components/PageHeaderComponent';
import ProvincialApplicableRates from '../Feature/Claims/components/ProvincialApplicableRates';
import ProvincialApplicableRatesTable from '../Feature/Claims/components/ProvincialApplicableRatesTable';
import RefundManagement from '../Feature/Claims/components/RefundManagement';
import Left3Right9 from '../Feature/ColumnLayouts/components/Left-3-Right-9';
import Left4Right8 from '../Feature/ColumnLayouts/components/Left-4-Right-8';
import Left8Right4 from '../Feature/ColumnLayouts/components/Left-8-Right-4';
import Announcement from '../Feature/DashboardComponents/components/Announcement';
import AnnouncementsColumn from '../Feature/DashboardComponents/components/AnnouncementsColumn';
import DashboardCards from '../Feature/DashboardComponents/components/DashboardCards';
import DashboardNavigationCard from '../Feature/DashboardComponents/components/DashboardNavigationCard';
import DefaultSubmissionForm from '../Feature/DefaultSubmissionForm/components/DefaultSubmissionForm';
import DefaultSubmissionFormProgress from '../Feature/DefaultSubmissionForm/components/DefaultSubmissionFormProgress';
import ErrorMessage from '../Feature/DefaultSubmissionForm/components/ErrorMessage';
import FormCardHeader from '../Feature/DefaultSubmissionForm/components/FormCardHeader';
import FormInputCalendar from '../Feature/DefaultSubmissionForm/components/FormInputCalendar';
import FormInputCheckbox from '../Feature/DefaultSubmissionForm/components/FormInputCheckbox';
import FormInputCurrency from '../Feature/DefaultSubmissionForm/components/FormInputCurrency';
import FormInputDropdownText from '../Feature/DefaultSubmissionForm/components/FormInputDropdownText';
import FormInputMultiLineText from '../Feature/DefaultSubmissionForm/components/FormInputMultiLineText';
import FormInputRadio from '../Feature/DefaultSubmissionForm/components/FormInputRadio';
import FormInputRange from '../Feature/DefaultSubmissionForm/components/FormInputRange';
import FormInputTextInput from '../Feature/DefaultSubmissionForm/components/FormInputTextInput';
import FormInputWholeNumber from '../Feature/DefaultSubmissionForm/components/FormInputWholeNumber';
import FormNumberInput from '../Feature/DefaultSubmissionForm/components/FormNumberInput';
import HomeownerLoanCheck from '../Feature/DefaultSubmissionForm/components/HomeownerLoanCheck';
import TopErrorMessages from '../Feature/DefaultSubmissionForm/components/TopErrorMessages';
import DefaultFormContext from '../Feature/DefaultsInventory/components/DefaultFormContext';
import DefaultInventoryDetails from '../Feature/DefaultsInventory/components/DefaultInventoryDetails';
import DefaultsInventoryTable from '../Feature/DefaultsInventory/components/DefaultsInventoryTable';
import AddDelegateAuthority from '../Feature/DelegateAuthority/components/AddDelegateAuthority';
import DelegateAuthority from '../Feature/DelegateAuthority/components/DelegateAuthority';
import ApplicationError from '../Feature/Errors/components/ApplicationError';
import Error404 from '../Feature/Errors/components/Error404';
import Error500 from '../Feature/Errors/components/Error500';
import FooterComponent from '../Feature/Footer/components/FooterComponent';
import HeaderComponent from '../Feature/Header/components/HeaderComponent';
import LanguageSwitcher from '../Feature/Header/components/LanguageSwitcher';
import NotificationFlyoutsComponent from '../Feature/Header/components/NotificationFlyoutsComponent';
import Notifications from '../Feature/Header/components/Notifications';
import SideMenu from '../Feature/Header/components/SideMenu';
import HelpSupportPage from '../Feature/HelpSupport/components/HelpSupportPage';
import HelpSupportSideMenuComponent from '../Feature/HelpSupport/components/HelpSupportSideMenuComponent';
import HelpSupportSideMenuLink from '../Feature/HelpSupport/components/HelpSupportSideMenuLink';
import SignInArea from '../Feature/LandingPage/components/SignInArea';
import Breadcrumb from '../Feature/PageComponents/components/Breadcrumb';
import CancellationReasonComponent from '../Feature/PageComponents/components/CancellationReasonComponent';
import ContentBlock from '../Feature/PageComponents/components/ContentBlock';
import ContentBlockInCard from '../Feature/PageComponents/components/ContentBlockInCard';
import ContentLoadingModal from '../Feature/PageComponents/components/ContentLoadingModal';
import GlossaryComponent from '../Feature/PageComponents/components/GlossaryComponent';
import HelpContentComponent from '../Feature/PageComponents/components/HelpContentComponent';
import HelpTopicsComponent from '../Feature/PageComponents/components/HelpTopicsComponent';
import PageWelcomeBar from '../Feature/PageComponents/components/PageWelcomeBar';
import ChangeStatusConfirmationComponent from '../Feature/PreClaims/components/ChangeStatusConfirmationComponent';
import PreApprovedPropertyRepairs from '../Feature/PreClaims/components/PreApprovedPropertyRepairs';
import PreClaimsItmFlags from '../Feature/PreClaims/components/PreClaimsItmFlags';
import PreClaimsUnderwritingReview from '../Feature/PreClaims/components/PreClaimsUnderwritingReview';
import SessionTimeoutModalComponent from '../Feature/SessionTimeoutModal/components/SessionTimeoutModalComponent';
import TermsAndConditions from '../Feature/TermsAndConditionsPage/components/TermsAndConditions';
import AddExternalUser from '../Feature/UserManagement/components/AddExternalUser';
import AddUser from '../Feature/UserManagement/components/AddUser';
import ManageUsersExternal from '../Feature/UserManagement/components/ManageUsersExternal';
import ManageUsersInternal from '../Feature/UserManagement/components/ManageUsersInternal';
import ModifyExternalUser from '../Feature/UserManagement/components/ModifyExternalUser';
import ModifyUser from '../Feature/UserManagement/components/ModifyUser';
import HbtBreadcrumbComponent from '../Feature/V2/HbtBreadcrumb/components/HbtBreadcrumbComponent';
import HbtDashboardCard from '../Feature/V2/HbtDashboard/components/HbtDashboardCard';
import HbtDashboardComponent from '../Feature/V2/HbtDashboard/components/HbtDashboardComponent';
import HbtDashboardLayout from '../Feature/V2/HbtDashboard/components/HbtDashboardLayout';
import HbtDashboardSideNavigation from '../Feature/V2/HbtDashboard/components/HbtDashboardSideNavigation';
import HbtDashboardPlaceHolderComponent from '../Feature/V2/HbtDashboardPlaceHolder/components/HbtDashboardPlaceHolderComponent';
import HbtGenericErrorPage from '../Feature/V2/HbtErrorPages/components/HbtGenericErrorPage';
import HbtFooterComponent from '../Feature/V2/HbtFooter/components/HbtFooterComponent';
import HbtFooterPlaceHolderComponent from '../Feature/V2/HbtFooterPlaceHolder/components/HbtFooterPlaceHolderComponent';
import HbtGenericHeaderComponent from '../Feature/V2/HbtHeader/components/HbtGenericHeaderComponent';
import HbtHeaderComponent from '../Feature/V2/HbtHeader/components/HbtHeaderComponent';
import HbtHeaderSideMenu from '../Feature/V2/HbtHeader/components/HbtHeaderSideMenu';
import HbtLanguageSwitcher from '../Feature/V2/HbtHeader/components/HbtLanguageSwitcher';
import HbtHeaderPlaceHolderComponent from '../Feature/V2/HbtHeaderPlaceHolder/components/HbtHeaderPlaceHolderComponent';
import HbtLoginPage from '../Feature/V2/HbtLogin/components/HbtLoginPage';
import HbtMasterPool from '../Feature/V2/HbtMasterPool/components/HbtMasterPool';
import HbtMasterPoolDetails from '../Feature/V2/HbtMasterPool/components/HbtMasterPoolDetails';
import HbtMasterPoolLoansInventoryTable from '../Feature/V2/HbtMasterPool/components/HbtMasterPoolLoansInventoryTable';
import HbtMasterPoolPremiumsAndTaxes from '../Feature/V2/HbtMasterPool/components/HbtMasterPoolPremiumsAndTaxes';
import HbtMasterPoolTable from '../Feature/V2/HbtMasterPool/components/HbtMasterPoolTable';
import HbtPIFileTransferDownloadTabView from '../Feature/V2/HbtPIFileTransfer/components/HbtPIFileTransferDownloadTabView';
import HbtPIFileTransferPage from '../Feature/V2/HbtPIFileTransfer/components/HbtPIFileTransferPage';
import HbtPIFileTransferUploadTabView from '../Feature/V2/HbtPIFileTransfer/components/HbtPIFileTransferUploadTabView';
import HbtPIRequestPage from '../Feature/V2/HbtPIRequest/components/HbtPIRequestPage';
import HbtPortfolioManagementPage from '../Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementPage';
import HbtPortfolioManagementRequestOverview from '../Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview';
import HbtPortfolioManagementTable from '../Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementTable';
import StatusPill from '../Feature/V2/HbtPortfolioManagement/components/StatusPill';
import HbtPurposeTestReport from '../Feature/V2/HbtPurposeTestReport/components/HbtPurposeTestReport';
import HbtSessionTimeoutModalComponent from '../Feature/V2/HbtSessionTimeoutModal/components/HbtSessionTimeoutModalComponent';
import HbtSessionTimeoutModalPlaceHolderComponent from '../Feature/V2/HbtSessionTimeoutModalPlaceHolder/components/HbtSessionTimeoutModalPlaceHolderComponent';
import HbtSupportPageComponent from '../Feature/V2/HbtSupport/components/HbtSupportPageComponent';
import HbtTermsAndConditionsComponent from '../Feature/V2/HbtTermsAndConditions/components/HbtTermsAndConditionsComponent';
import HbtTermsAndConditionsPlaceHolderComponent from '../Feature/V2/HbtTermsAndConditionsPlaceHolder/components/HbtTermsAndConditionsPlaceHolderComponent';
import HbtAddExternalPIUser from '../Feature/V2/HbtUserAccessManagement/components/HbtAddExternalPIUser';
import HbtAddInternalPIUser from '../Feature/V2/HbtUserAccessManagement/components/HbtAddInternalPIUser';
import HbtModifyExternalPIUser from '../Feature/V2/HbtUserAccessManagement/components/HbtModifyExternalPIUser';
import HbtModifyInternalPIUser from '../Feature/V2/HbtUserAccessManagement/components/HbtModifyInternalPIUser';
import HbtUserAccessManagementPage from '../Feature/V2/HbtUserAccessManagement/components/HbtUserAccessManagementPage';
import DiscreteSlider from '../Feature/V2/Shared_Portfolio/components/DiscreteSlider';
import InputField from '../Feature/V2/Shared_Portfolio/components/InputField';
import ResetIcon from '../Feature/V2/Shared_Portfolio/components/ResetIcon';
import SearchFlyout from '../Feature/V2/Shared_Portfolio/components/SearchFlyout';

const components = new Map();
components.set('ApprovalForm', ApprovalForm);
components.set('ApprovalsFinancialAuth', ApprovalsFinancialAuth);
components.set('ArrearsErrorRecord', ArrearsErrorRecord);
components.set('ArrearsFileList', ArrearsFileList);
components.set('ArrearsHistoricalFlyout', ArrearsHistoricalFlyout);
components.set('ArrearsHistoricalRecords', ArrearsHistoricalRecords);
components.set('ArrearsResources', ArrearsResources);
components.set('ArrearsSubmissionForm', ArrearsSubmissionForm);
components.set('ArrearsSubmissionListDetails', ArrearsSubmissionListDetails);
components.set('ArrearsSummaryReport', ArrearsSummaryReport);
components.set('DisplayNotificationCard', DisplayNotificationCard);
components.set('ReplaceArrears', ReplaceArrears);
components.set('SubmissionList', SubmissionList);
components.set('SignInComplete', SignInComplete);
components.set('ClaimsInventory', ClaimsInventory);
components.set('ClaimsSubmissionForm', ClaimsSubmissionForm);
components.set('Details', Details);
components.set('HBTFormContext', HBTFormContext);
components.set('IndicatorDetailsFields', IndicatorDetailsFields);
components.set('PageHeaderComponent', PageHeaderComponent);
components.set('ProvincialApplicableRates', ProvincialApplicableRates);
components.set('ProvincialApplicableRatesTable', ProvincialApplicableRatesTable);
components.set('RefundManagement', RefundManagement);
components.set('Left-3-Right-9', Left3Right9);
components.set('Left-4-Right-8', Left4Right8);
components.set('Left-8-Right-4', Left8Right4);
components.set('Announcement', Announcement);
components.set('AnnouncementsColumn', AnnouncementsColumn);
components.set('DashboardCards', DashboardCards);
components.set('DashboardNavigationCard', DashboardNavigationCard);
components.set('DefaultSubmissionForm', DefaultSubmissionForm);
components.set('DefaultSubmissionFormProgress', DefaultSubmissionFormProgress);
components.set('ErrorMessage', ErrorMessage);
components.set('FormCardHeader', FormCardHeader);
components.set('FormInputCalendar', FormInputCalendar);
components.set('FormInputCheckbox', FormInputCheckbox);
components.set('FormInputCurrency', FormInputCurrency);
components.set('FormInputDropdownText', FormInputDropdownText);
components.set('FormInputMultiLineText', FormInputMultiLineText);
components.set('FormInputRadio', FormInputRadio);
components.set('FormInputRange', FormInputRange);
components.set('FormInputTextInput', FormInputTextInput);
components.set('FormInputWholeNumber', FormInputWholeNumber);
components.set('FormNumberInput', FormNumberInput);
components.set('HomeownerLoanCheck', HomeownerLoanCheck);
components.set('TopErrorMessages', TopErrorMessages);
components.set('DefaultFormContext', DefaultFormContext);
components.set('DefaultInventoryDetails', DefaultInventoryDetails);
components.set('DefaultsInventoryTable', DefaultsInventoryTable);
components.set('AddDelegateAuthority', AddDelegateAuthority);
components.set('DelegateAuthority', DelegateAuthority);
components.set('ApplicationError', ApplicationError);
components.set('Error404', Error404);
components.set('Error500', Error500);
components.set('FooterComponent', FooterComponent);
components.set('HeaderComponent', HeaderComponent);
components.set('LanguageSwitcher', LanguageSwitcher);
components.set('NotificationFlyoutsComponent', NotificationFlyoutsComponent);
components.set('Notifications', Notifications);
components.set('SideMenu', SideMenu);
components.set('HelpSupportPage', HelpSupportPage);
components.set('HelpSupportSideMenuComponent', HelpSupportSideMenuComponent);
components.set('HelpSupportSideMenuLink', HelpSupportSideMenuLink);
components.set('SignInArea', SignInArea);
components.set('Breadcrumb', Breadcrumb);
components.set('CancellationReasonComponent', CancellationReasonComponent);
components.set('ContentBlock', ContentBlock);
components.set('ContentBlockInCard', ContentBlockInCard);
components.set('ContentLoadingModal', ContentLoadingModal);
components.set('GlossaryComponent', GlossaryComponent);
components.set('HelpContentComponent', HelpContentComponent);
components.set('HelpTopicsComponent', HelpTopicsComponent);
components.set('PageWelcomeBar', PageWelcomeBar);
components.set('ChangeStatusConfirmationComponent', ChangeStatusConfirmationComponent);
components.set('PreApprovedPropertyRepairs', PreApprovedPropertyRepairs);
components.set('PreClaimsItmFlags', PreClaimsItmFlags);
components.set('PreClaimsUnderwritingReview', PreClaimsUnderwritingReview);
components.set('SessionTimeoutModalComponent', SessionTimeoutModalComponent);
components.set('TermsAndConditions', TermsAndConditions);
components.set('AddExternalUser', AddExternalUser);
components.set('AddUser', AddUser);
components.set('ManageUsersExternal', ManageUsersExternal);
components.set('ManageUsersInternal', ManageUsersInternal);
components.set('ModifyExternalUser', ModifyExternalUser);
components.set('ModifyUser', ModifyUser);
components.set('HbtBreadcrumbComponent', HbtBreadcrumbComponent);
components.set('HbtDashboardCard', HbtDashboardCard);
components.set('HbtDashboardComponent', HbtDashboardComponent);
components.set('HbtDashboardLayout', HbtDashboardLayout);
components.set('HbtDashboardSideNavigation', HbtDashboardSideNavigation);
components.set('HbtDashboardPlaceHolderComponent', HbtDashboardPlaceHolderComponent);
components.set('HbtGenericErrorPage', HbtGenericErrorPage);
components.set('HbtFooterComponent', HbtFooterComponent);
components.set('HbtFooterPlaceHolderComponent', HbtFooterPlaceHolderComponent);
components.set('HbtGenericHeaderComponent', HbtGenericHeaderComponent);
components.set('HbtHeaderComponent', HbtHeaderComponent);
components.set('HbtHeaderSideMenu', HbtHeaderSideMenu);
components.set('HbtLanguageSwitcher', HbtLanguageSwitcher);
components.set('HbtHeaderPlaceHolderComponent', HbtHeaderPlaceHolderComponent);
components.set('HbtLoginPage', HbtLoginPage);
components.set('HbtMasterPool', HbtMasterPool);
components.set('HbtMasterPoolDetails', HbtMasterPoolDetails);
components.set('HbtMasterPoolLoansInventoryTable', HbtMasterPoolLoansInventoryTable);
components.set('HbtMasterPoolPremiumsAndTaxes', HbtMasterPoolPremiumsAndTaxes);
components.set('HbtMasterPoolTable', HbtMasterPoolTable);
components.set('HbtPIFileTransferDownloadTabView', HbtPIFileTransferDownloadTabView);
components.set('HbtPIFileTransferPage', HbtPIFileTransferPage);
components.set('HbtPIFileTransferUploadTabView', HbtPIFileTransferUploadTabView);
components.set('HbtPIRequestPage', HbtPIRequestPage);
components.set('HbtPortfolioManagementPage', HbtPortfolioManagementPage);
components.set('HbtPortfolioManagementRequestOverview', HbtPortfolioManagementRequestOverview);
components.set('HbtPortfolioManagementTable', HbtPortfolioManagementTable);
components.set('StatusPill', StatusPill);
components.set('HbtPurposeTestReport', HbtPurposeTestReport);
components.set('HbtSessionTimeoutModalComponent', HbtSessionTimeoutModalComponent);
components.set('HbtSessionTimeoutModalPlaceHolderComponent', HbtSessionTimeoutModalPlaceHolderComponent);
components.set('HbtSupportPageComponent', HbtSupportPageComponent);
components.set('HbtTermsAndConditionsComponent', HbtTermsAndConditionsComponent);
components.set('HbtTermsAndConditionsPlaceHolderComponent', HbtTermsAndConditionsPlaceHolderComponent);
components.set('HbtAddExternalPIUser', HbtAddExternalPIUser);
components.set('HbtAddInternalPIUser', HbtAddInternalPIUser);
components.set('HbtModifyExternalPIUser', HbtModifyExternalPIUser);
components.set('HbtModifyInternalPIUser', HbtModifyInternalPIUser);
components.set('HbtUserAccessManagementPage', HbtUserAccessManagementPage);
components.set('DiscreteSlider', DiscreteSlider);
components.set('InputField', InputField);
components.set('ResetIcon', ResetIcon);
components.set('SearchFlyout', SearchFlyout);

export default function componentFactory(componentName: string) {
  return components.get(componentName);
}
